<template>
  <div class="flow-root">
    <div class="">
      <!-- overflow-auto -->
      <!-- py-2 -->
      <div class="inline-block w-full align-middle">
        <div v-if="props.title" class="pt-4 flex flex-row w-full">
          <div class="flex flex-row items-center grow">
            <div>
              <h3
                class="text-base font-semibold leading-6 text-gray-900 dark:text-gray-300 pr-4"
              >
                {{ props.title }}
              </h3>
              <p class="mt-2 text-sm text-gray-700" v-if="$props.subtitle">
                {{ props.subtitle }}
              </p>
            </div>
            <slot name="tabs"> </slot>
          </div>

          <div><slot name="button-slot"> </slot></div>
        </div>

        <div>
          <slot name="above-table"> </slot>
        </div>

        <div :class="props.noTopPadding ? 'pt-0' : 'pt-4'">
          <slot v-if="!props.loading"></slot>
          <div v-else class="shadow bg-white rounded-lg w-full">
            <Spinner />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
const props = defineProps(["title", "subtitle", "loading", "noTopPadding"]);
import { useSlots } from "vue";
import Spinner from "./utils/Spinner.vue";

const slots = useSlots();
</script>
